import { addContactToCounterparty } from './addContactToCounterparty'
import { deleteContactToCounterparty } from './deleteContactToCounterparty'
import { updateContactToCounterparty } from './updateContactToCounterparty'
import { getCounterparties } from './getCounterparties'
import { getCounterpartiesOptions } from './getCounterpartiesOptions'
import { getCounterpartyById } from './getCounterpartyById'
import { exportAnalytics } from './exportAnalytics'

export const CounterpartiesApi = {
    exportAnalytics,
    getCounterparties,
    getCounterpartiesOptions,
    getCounterpartyById,
    addContactToCounterparty,
    deleteContactToCounterparty,
    updateContactToCounterparty,
}
